import React from 'react';
import { PropTypes } from 'prop-types';

import { Heart } from 'components/ui/icons';
import CleanButton from 'components/utils/CleanButton';

import './styles.scss';

const Favorite = ({ onClick, toggled, className, style, ...props }) => {

  const favoriteComponent = (
    <div className={`favorite-wrapper ${toggled ? 'toggled' : ''}`}>
      <Heart/>
      <span></span>
    </div>
  )

  return onClick ? (
    <CleanButton onClick={onClick} className={className} style={{ lineHeight: 0, ...style }} alt="Favorite" title="Favorite" {...props}>
      {favoriteComponent}
    </CleanButton>
  ) : (
    <div className={className} {...props}>
      {favoriteComponent}
    </div>
  )
};

Favorite.propTypes = {
  onClick: PropTypes.func,
  toggled: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
};

Favorite.defaultProps = {
  onClick:  undefined,
  toggled: true,
  className: '',
  style: {}
};

export default Favorite;
